import { ContentInstructions, CoreContents, ExportOptions, FromSettingsInstruction } from '../../../types';
import { DataOptionsFactory } from '../data';
import { ContentFactory } from './base';

export type StatsTableOptions = {
  data?: DataOptionsFactory;
  title?: string;
  rowIdField: string | FromSettingsInstruction;
  exportOptions?: ExportOptions;
};
export class StatsTableFactory extends ContentFactory {
  constructor(options: StatsTableOptions) {
    const { data, rowIdField, title, exportOptions } = options;

    const instructions: ContentInstructions = {
      rowIdField:
        typeof rowIdField === 'string'
          ? {
              type: 'StringInstruction',
              instruction: rowIdField,
            }
          : rowIdField,
      ...(exportOptions && {
        export: {
          type: 'ObjectInstruction',
          instruction: exportOptions,
        },
      }),
    };

    if (title) {
      instructions.title = {
        type: 'StringInstruction',
        instruction: title,
      };
    }

    super(CoreContents.statsTable, {
      data: data || DataOptionsFactory.asReceiver(),
      instructions,
    });
  }
}
